import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  post(endPoint: string, params: any = {}): Observable<any> {
    return this.http.post(environment.API_ENDPOINT + endPoint, JSON.stringify(params)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 403) {
          console.error('Access denied (403):', error.message);
          return throwError(() => new Error('You do not have permission to access this resource.'));
        }

        if (error.status == 500) {
          console.error('Server error (500):', error.message);
          return throwError(() => new Error('Server error. Please try again later.'));
        }

        console.error('HTTP Error:', error.message);
        return throwError(() => new Error('Something went wrong.'));
      })
    );
  }
}
